<template>
  <div>
    <div>
      <div class="d-flex date-picker">
        <div style="padding: 0 !important">
          <select
            Class="SelectCss"
            @change="editValue('date', $event)"
            v-model="date"
            style="width: 90px !important; height:36px"
          >
            <option value="">Date</option>
            <option v-for="i in daysInMonth" :key="i" :value="i">
              {{ i }}
            </option>
          </select>
        </div>
        <div style="padding: 0 !important">
          <select
            Class="SelectCss"
            @change="editValue('months', $event)"
            v-model="month"
            style="width: 90px !important; height:36px"
          >
            <option value="">Month</option>
            <option v-for="(i, index) in monthss" :key="i" :value="index">
              {{ i }}
            </option>
          </select>
        </div>
        <div style="padding: 0 !important">
          <select
            Class="SelectCss"
            @change="editValue('year', $event)"
            v-model="year"
            style="width: 90px !important; height:36px;"
          >
            <option value="">Year</option>
            <option
              v-for="i in this.getNumberofYears()"
              :key="i"
              :value="this.getStartYear() + i"
            >
              {{ this.getStartYear() + i }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "DatePicker",
  components: {},
  data() {
    return {
      dateValue: moment(),
      monthss: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      month: "",
      date: "",
      year: "",
      numberofYears: 74,
      startingYear: 1950,
      daysInMonth: 31,
    };
  },
  props: {
    modelValue: {
      type: String,
      default: "",
    },
  },

  mounted() {
    this.updateElements();
  },
  methods: {
    getStartYear() {
      var currentYear = moment().format("YYYY");
      return currentYear - this.getNumberofYears();
    },
    getNumberofYears() {
      return this.numberofYears;
    },
    editValue(unit, evt) {
      this.dateValue.set(unit, evt.target.value);
      this.updateElements("EDIT", unit);
      this.$emit("update", { date: this.dateValue });
    },
    setDateValueData(modelValue) {
      var date = moment();
      if (modelValue != "0000-00-00") {
        date = moment(modelValue).format("YYYY-MM-DD");
      }
      this.dateValue = moment(date);
      if (this.dateValue) {
        this.year = this.dateValue.format("YYYY");
        this.month = this.dateValue.month();
        this.date = this.dateValue.date();
      }
      // this.updateElements("EDIT");
    },
    updateElements(type, unit) {
      if (type) {
        if (unit == "months") {
          this.month = this.dateValue.month();
        }
        if (unit == "date") {
          this.date = this.dateValue.date();
        }
        if (unit == "year") {
          this.year = this.dateValue.format("YYYY");
        }
      }
    },
  },
};
</script>

<style>
.SelectCss {
  font-size: 13px;
  background: white;
  outline: none;
  box-shadow: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  width: 70px;
  margin: 0px 2px;
  height: 32px;
  color: #495057;
}
</style>
